module.exports = __webpack_public_path__ + "static/media/AJLT_Reel.2c77f437.mp4";